export default {
  router: {},
  prevRoute: null,
  routeLoading: true,
  isSuperUser: false,
};
